import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';
import { type CardLayoutModelConstructorType } from '../../types';

export class OwnerName extends Field {
  static subqueriesForModel(
    modelClass: CardLayoutModelConstructorType
  ): Record<string, any> {
    return { owner: ['name'] };
  }

  get title() {
    return 'Owner name';
  }

  exampleContents(): FieldContentsData {
    return { text: 'Assigned to user' };
  }

  contentsForRecord(record): FieldContentsData {
    return { text: record.owner?.name };
  }
}
